import { Breadcrumb, Button, Empty, Rate, Tag } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { HomeOutlined } from '@ant-design/icons'
import { Card, Col, Row } from 'react-bootstrap'
import { DEFAULT_THUMBNAIL } from '../../../constants/otherConstsnts'
import LoadingComp from '../../../components/LoadingComp'
import { PhotoProvider, PhotoView } from 'react-photo-view'

import ReactQuill from 'react-quill'
import { capitalizeFisrtLetterEachWord, resizeString } from '../../../helpers/nameRender'
import { getFacilityIcon } from '../../../helpers/iconsRender'
import './styles.scss'
import '../../Tours/TourPackage/styles.scss'
import { getAccommodationById, getAccommodationPackagesByAccommodation, getAccommodationFacilities, getAccommodationHouseRules, getAccommodationMealInfo } from '../../../../redux/api/accommodations.api'
import { convertCurrency } from '../../../helpers/currencyConverter'
import useCurrencyRates from '../../../hooks/useCurrencyRates'
import usePageSettings from '../../../hooks/usePageSettings'

const Hotel = () => {
    const id = window.location.pathname.split('/').pop()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [hotel, setHotel] = useState(null)
    const [packages, setPackages] = useState([])
    const [facilities, setFacilities] = useState([])
    const [houseRules, setHouseRules] = useState(null)
    const [mealInfo, setMealInfo] = useState([])
    const currencyRates = useCurrencyRates()?.currencyRates
    const selectedCurrency = usePageSettings()?.selectedCurrency;

    useEffect(() => {
        window.scrollTo(0, 0)
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fetchData = async () => {
        setLoading(true)
        const [h, p, f, hr, m] = await Promise.all([
            getAccommodationById(id),
            getAccommodationPackagesByAccommodation(id),
            getAccommodationFacilities(id),
            getAccommodationHouseRules(id),
            getAccommodationMealInfo(id)
        ])
        if (h && h.data) setHotel(Array.isArray(h.data) ? h.data[0] : h.data)
        if (p && p.data) setPackages(p.data)
        if (f && f.data) setFacilities(f.data)
        if (hr && hr.data) setHouseRules(hr.data)
        if (m && m.data) setMealInfo(m.data)
        setLoading(false)
    }

    const renderImages = (images) => {
        if (!images || images.length === 0) return null

        if (images.length > 2) {
            const moreImages = images.slice(2)
            return (
                <div className='images_container more_than_two'>
                    <PhotoView src={images[0]}>
                        <span>
                            <LazyLoadImage
                                alt='image'
                                effect="blur"
                                wrapperProps={{
                                    style: { transitionDelay: "0.1s" },
                                }}
                                src={images[0]}
                            />
                        </span>
                    </PhotoView>
                    <PhotoView src={images[1]}>
                        <span>
                            <LazyLoadImage
                                alt='image'
                                effect="blur"
                                wrapperProps={{
                                    style: { transitionDelay: "0.1s" },
                                }}
                                src={images[1]}
                            />
                        </span>
                    </PhotoView>
                    <div className='more_images'>
                        {
                            moreImages.map((image, index) => (
                                <PhotoView key={index} src={image}>
                                    <span key={index}>
                                        <LazyLoadImage
                                            alt='image'
                                            effect="blur"
                                            wrapperProps={{
                                                style: { transitionDelay: "0.1s" },
                                            }}
                                            src={image}
                                        />
                                    </span>
                                </PhotoView>
                            ))
                        }
                    </div>
                </div>
            )
        } else {
            return (
                <div className='images_container'>
                    {
                        images?.map((image, index) => (
                            <PhotoView key={index} src={image}>
                                <span key={index}>
                                    <LazyLoadImage
                                        alt='image'
                                        effect="blur"
                                        wrapperProps={{
                                            style: { transitionDelay: "0.1s" },
                                        }}
                                        src={image}
                                    />
                                </span>
                            </PhotoView>
                        ))
                    }
                </div>
            )
        }
    }

    if (loading) {
        return (
            <div className='loading_page'>
                <LoadingComp />
            </div>
        )
    }

    if (!hotel) {
        return (
            <div className='not_found'
                style={{
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column'
                }}
            >
                <Empty description={<span>Hotel not found</span>} />
            </div>
        )
    }

    return (
        <div className='main__contaier accommodation_hotel_page section_main'>
            <div className='hero top_margin_main'>
                <div className='hero__background__overlay'></div>
                <div className='hero__background'>
                    <LazyLoadImage
                        alt='background-image'
                        effect="blur"
                        wrapperProps={{
                            style: { transitionDelay: "0.1s" },
                        }}
                        src={hotel?.thumbnailUrl || 'https://visitpearlsharedblob.blob.core.windows.net/appassets/accommodations_bg.webp'}
                    />
                </div>

                <div className='hero__content_header'>
                    <Breadcrumb
                        className='breadcrumb_pages'
                        items={[
                            {
                                title: <div className='breadcrumb__item' onClick={() => navigate('/')}><HomeOutlined /> Home</div>,
                            },
                            {
                                title: <div className='breadcrumb__item' onClick={() => navigate('/accommodations')} >Accommodations</div>,
                            },
                            {
                                title: <div className='breadcrumb__item last' >
                                    {hotel?.accommodationName}
                                </div>,
                            },
                        ]}
                    />
                </div>

                <h1 data-aos="fade-up" data-aos-delay="300" className='header_1 align_start'>
                    {hotel?.accommodationName}
                </h1>
            </div>

            <div className='tour_package_content_body'>
                <div className='content__container'>
                    <div className='image_gallery'>
                        <PhotoProvider>
                            <div className='left'>
                                <PhotoView src={hotel?.thumbnailUrl}>
                                    <LazyLoadImage
                                        alt='image'
                                        effect="blur"
                                        wrapperProps={{
                                            style: { transitionDelay: "0.1s" },
                                        }}
                                        src={hotel && (hotel?.thumbnailUrl || DEFAULT_THUMBNAIL)}
                                    />
                                </PhotoView>
                            </div>
                            <div className='right'>
                                {hotel?.accommodationImages && renderImages(hotel.accommodationImages.split(','))}
                            </div>
                            <div className='total'>
                                <span>{(hotel?.accommodationImages ? hotel.accommodationImages.split(',').length : 0) + (hotel?.thumbnailUrl ? 1 : 0)} photos</span>
                            </div>
                        </PhotoProvider>
                    </div>

                    <section className='sec__1'>
                        <div className='tags'>
                            {
                                hotel?.tags && hotel.tags.split(',').map((tag, index) => (
                                    <Tag key={index} className='tag'>{tag}</Tag>
                                ))
                            }
                        </div>

                        <div className='short_details'>
                            <div className='row_cus'>
                                <div className='col_cus'>
                                    <div className='title'>Hotel Type:</div>
                                    <div className='value'>{hotel?.accommodationType &&
                                        capitalizeFisrtLetterEachWord(hotel?.accommodationType)} </div>
                                </div>

                                <div className='col_cus'>
                                    <div className='title'>City:</div>
                                    <div className='value'>{hotel?.accommodationCity &&
                                        capitalizeFisrtLetterEachWord(hotel?.accommodationCity)} </div>
                                </div>

                                <div className='col_cus'>
                                    <Rate disabled allowHalf defaultValue={Number(hotel?.starRating) || 0} /> <span className='rating'>{hotel?.starRating} Star Rating</span>
                                </div>
                            </div>
                        </div>

                        <div className='about'>
                            <h2 className='heder_2'>About this hotel</h2>
                            <ReactQuill value={hotel?.accommodationDescription} readOnly={true} theme='bubble' />
                        </div>

                        {hotel?.mapLocation && (
                            <div className='map_section'>
                                <h2 className='heder_2'>Location</h2>
                                <div className='map_container'>
                                    <iframe
                                        src={hotel.mapLocation}
                                        width="100%"
                                        height="400"
                                        style={{ border: 0 }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        title={`${hotel.accommodationName} location`}
                                    />
                                </div>
                                {hotel?.accommodationAddress && (
                                    <div className='address_info'>
                                        <p><strong>Address:</strong> {hotel.accommodationAddress}</p>
                                    </div>
                                )}
                                {hotel?.accommodationCoordinates && (
                                    <div className='coordinates_info'>
                                        <p><strong>Coordinates:</strong> {hotel.accommodationCoordinates}</p>
                                    </div>
                                )}
                            </div>
                        )}

                        {facilities && facilities.length > 0 && (
                            <div className='facilities_section'>
                                <h2 className='heder_2'>Facilities & Amenities</h2>
                                <div className='facilities_grid'>
                                    {facilities.map((facility, index) => (
                                        <div key={index} className='facility_item'>
                                            <div className='facility_icon'>
                                                {getFacilityIcon(facility.facilityType)}
                                            </div>
                                            <div className='facility_content'>
                                                <h3>{facility.facilityName}</h3>
                                                {facility.facilityDescription && (
                                                    <p>{facility.facilityDescription}</p>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {houseRules && (
                            <div className='house_rules_section'>
                                <h2 className='heder_2'>House Rules & Policies</h2>
                                <div className='rules_grid'>
                                    <div className='rule_item'>
                                        <h3>Check-in & Check-out</h3>
                                        <p><strong>Check-in:</strong> {houseRules.checkInTime}</p>
                                        <p><strong>Check-out:</strong> {houseRules.checkOutTime}</p>
                                    </div>
                                    {houseRules.cancellationPolicy && (
                                        <div className='rule_item'>
                                            <h3>Cancellation Policy</h3>
                                            <div className='policy_content'>
                                                {houseRules.cancellationPolicy.split('\n').map((line, index) => (
                                                    <p key={index}>{line}</p>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {houseRules.paymentPolicy && (
                                        <div className='rule_item'>
                                            <h3>Payment Policy</h3>
                                            <p>{houseRules.paymentPolicy}</p>
                                        </div>
                                    )}
                                    {houseRules.childPolicy && (
                                        <div className='rule_item'>
                                            <h3>Child Policy</h3>
                                            <div className='policy_content'>
                                                {houseRules.childPolicy.split('\n').map((line, index) => (
                                                    <p key={index}>{line}</p>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {houseRules.petPolicy && (
                                        <div className='rule_item'>
                                            <h3>Pet Policy</h3>
                                            <p>{houseRules.petPolicy}</p>
                                        </div>
                                    )}
                                    {houseRules.smokingPolicy && (
                                        <div className='rule_item'>
                                            <h3>Smoking Policy</h3>
                                            <p>{houseRules.smokingPolicy}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {mealInfo && mealInfo.length > 0 && (
                            <div className='meals_section'>
                                <h2 className='heder_2'>Dining & Meals</h2>
                                <div className='meals_grid'>
                                    {mealInfo.map((meal, index) => (
                                        <div key={index} className='meal_item'>
                                            <div className='meal_header'>
                                                <h3>{meal.mealName}</h3>
                                                <span className='meal_type'>{meal.mealType}</span>
                                            </div>
                                            <div className='meal_description'>
                                                <p>{meal.mealDescription}</p>
                                            </div>
                                            {meal.mealPrice && (
                                                <div className='meal_price'>
                                                    <span>Price: ${meal.mealPrice}</span>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </section>

                    <h2 className='heder_2' style={{ marginTop: 20 }}>Packages</h2>
                    <Row xs={1} md={1} lg={1} xl={1} className="g-4">
                        {packages?.map((item, idx) => (
                            <Col key={idx}>
                                <Card className='tour__packages__main_card' data-aos="fade-up" data-aos-delay={`${idx * 50}`} onClick={() => navigate(`/accommodation-package/${item?.id}`)}>
                                    <Card.Body className='destination__card__content'>
                                        <div className='left'>
                                            <LazyLoadImage alt={item?.packageName} effect="blur" wrapperProps={{ style: { transitionDelay: "0.1s" } }} src={item?.packageImages?.split(',')[0] || DEFAULT_THUMBNAIL} />
                                        </div>
                                        <div className='right'>
                                            <h1>{item?.packageName}</h1>
                                            <ReactQuill value={resizeString(item?.packageDescription, 200)} readOnly={true} theme='bubble' />
                                            <div className='tags'>
                                                {item?.packageFacilities && (() => {
                                                    const tags = item.packageFacilities.split(',');
                                                    const visibleTags = tags.slice(0, 3);
                                                    const remainingCount = tags.length - 3;
                                                    return (
                                                        <>
                                                            {visibleTags.map((tag, index) => (
                                                                <Tag key={index}>{tag ? capitalizeFisrtLetterEachWord(tag) : 'N/A'}</Tag>
                                                            ))}
                                                            {remainingCount > 0 && (
                                                                <Tag>+{remainingCount} more</Tag>
                                                            )}
                                                        </>
                                                    );
                                                })()}
                                            </div>
                                            <div className='card_footer'>
                                                <div className='details max_details'></div>
                                                <div className='price'>
                                                    <h2>
                                                        <span>Price: </span>
                                                        {item?.packagePrice ? convertCurrency(item?.packagePrice, selectedCurrency, currencyRates) : 'N/A'} {selectedCurrency}
                                                    </h2>
                                                    <Button type='primary' onClick={() => navigate(`/accommodation-package/${item?.id}`)}>View Package</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                        {packages?.length === 0 && (
                            <div className='empty_cards'>
                                <Empty description={<span>No packages found</span>} />
                            </div>
                        )}
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default Hotel


